// extracted by mini-css-extract-plugin
module.exports = {"status":"IssueStatus_status_g8JU3"};